<template>
  <div class="container">
    <div class="row">
      <h1 class="text-center main-title" v-html="$t('title.news')">
        新闻
        <em>资讯</em>
        <span>News</span>
      </h1>
      <!-- <ul class="clearfix aside text-center">
        <li
          v-for="(item,index) in newsort"
          class="aside-title"
          :key="index"
          v-on:click="getDate(item.url)"
        >
          <router-link :to="'/news/'+item.id" key="index" exact>{{item.subname}}</router-link>
        </li>
      </ul> -->

      <div class="col-md-9">
        <ul class="news-list">
          <div class="row">
            <li v-for="(item,index) in news" class="box-border" :key="index">
              <router-link :to="'/news/details/'+item.id" key="index">
                <h2>{{item.title}}</h2>
                <p>{{item.body}}</p>
                <div>
                  <span class="news-date">{{item.addTime}}</span>
                  <span>
                    <i class="glyphicon glyphicon-eye-open"></i>
                    {{item.hits}}
                  </span>
                </div>
              </router-link>
            </li>
          </div>
        </ul>

        <nav aria-label="Page navigation" v-show="page != 1 ? true:false">
          <ul class="pagination">
            <li :class="{ 'disabled': currentPage == 1} ">
              <a href="javascript:;" aria-label="Previous" v-on:click="sub">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li v-for="(item,i) in page" :key="i" >
              <a href="javascript:;" v-on:click="addcurrentPage(i)" :class="{ 'active': (i+1) == currentPage}">{{i+1}}</a>
            </li>
            <li :class="{ 'disabled': page == currentPage}">
              <a href="javascript:;" aria-label="Next" v-on:click="add">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="col-md-3 recommend">
        <h3>
          <span>为你推荐</span>
        </h3>
        <ul class="recommend-list" v-for="(item,i) in recommend" :key="i">
          <li>
            <router-link
              :to="'/news/details/'+item.id"
              key="index"
              exact
              style="color:#333"
            >{{item.title}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from 'axios'
//import pagination from "@/components/pagination";

export default {
  name: "News",
   metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      newsList: {},
      news: {},
      recommend: {},
      total: "", // 数据总条数
      display: 6, // 每页显示条数
      currentPage: 1 // 当前页码
    
    };
  },
  computed: {
    newsort() {
      return this.$t("nav_foot[2].subnavigation");
    },
    page: function() {
      // 总页数
      return Math.ceil(this.total / this.display);
    },
    //页面的title
    
     pageName(){
      return this.$t("nav[3].name");
    }
  },
  watch: {
    $route() {
      //console.log(this.$route.params.newId);
      //this.getDate();
      var id = this.$route.params.newId;
      if (id == "industry") {
        id = "industry";
      } else {
        id = "company";
      }
      this.getDate(id);
    }
  },
  mounted() {
    // this.$http
    //   .get("http://www.hzjingbao.cn/api/news", {
    //     params: {
    //       lang: this.$i18n.locale,
    //       type: "company",
    //       page: this.currentPage,
    //       limit: this.display
    //     }
    //   })
    //   .then(res => {
    //     //console.log(res.data);
    //     this.news = res.data.rows;
    //     this.total = res.data.total;
    //     // console.log(this.total);
    //     //console.log(this.news);
    //   })
    //   .catch(erroe => {
    //     console.log(error);
    //   }),
      this.$http
        .get("http://www.hzjingbao.cn/api/random", {
          params: {
            lang: this.$i18n.locale
          }
        })
        .then(res => {
         // console.log(res.data);
          this.recommend = res.data;
          //console.log(this.news);
        })
        .catch(erroe => {
          console.log(error);
        });
  },
  methods: {
    getDate(index) {
      var id = this.$route.params.newId;
      this.currentPage=1;
      //console.log(this.$route.params.newId);
      sessionStorage.setItem("newId", index);
      this.$http
        .get("http://www.hzjingbao.cn/api/news", {
          params: {
            lang: this.$i18n.locale,
            type: index,
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.news = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    //分页选择当前页
    addcurrentPage(i) {
      //console.log(i + 1);
      this.currentPage=i+1;
      this.$http
        .get("http://www.hzjingbao.cn/api/news", {
          params: {
            lang: this.$i18n.locale,
            type: sessionStorage.getItem('newId'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.news = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    // 分页的右边按钮
    add(){
      this.currentPage +=1;
      if(this.currentPage>this.page){
        this.currentPage = this.page;
      }
       this.$http
        .get("http://www.hzjingbao.cn/api/news", {
          params: {
            lang: this.$i18n.locale,
            type: sessionStorage.getItem('newId'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.news = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    //分页的左边按钮
    sub(){
      this.currentPage -=1;
      if(this.currentPage<1){
        this.currentPage = 1;
      }
       this.$http
        .get("http://www.hzjingbao.cn/api/news", {
          params: {
            lang: this.$i18n.locale,
            type: sessionStorage.getItem('newId'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.news = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    }
  },
  created(){
    var id=this.$route.params.newId;
    //console.log(id)
     if (id == "industry") {
        id = "industry";
       
      } else {
        id = "company";
      }
      sessionStorage.setItem("newId", id);
     this.$http
      .get("http://www.hzjingbao.cn/api/news", {
        params: {
          lang: this.$i18n.locale,
          type: id,
          page: this.currentPage,
          limit: this.display
        }
      })
      .then(res => {
        console.log(res.data);
        this.news = res.data.rows;
        this.total = res.data.total;
        // console.log(this.total);
        //console.log(this.news);
      })
      .catch(erroe => {
        console.log(error);
      })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/news.vue